import { cn } from "@newxsystems/shared";
import type { IStratosSectionProps } from "./StratosSection.props";

export const StratosSection = ({
  children,
  className,
  containerClassName,
  containerWidth = "default",
  id,
  spacing,
}: IStratosSectionProps) => (
  <section
    className={cn("stratos-block-spacing bg-background text-foreground", className)}
    data-spacing={spacing || undefined}
    id={id || undefined}
  >
    <div
      className={cn("stratos-container", containerClassName)}
      data-container-width={containerWidth}
    >
      {children}
    </div>
  </section>
);

StratosSection.displayName = "Content::StratosSection";
